import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Text from './Text';
import Icon from './Icon';
import { palette } from '../../constants/styles';

const BulletsContainer = styled.ul`
  display: flex;
  flex-direction: column;
  justify-content: center
  align-content: flex-start;
  padding: 0px;
  width: 100%;
  height: 100%;
  justify-content: ${({ justifyContent }) => justifyContent};
  ${({ styles }) => styles};
`;

const Bullet = styled.li`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: flex-start;
  margin-bottom: 5px;
  ${({ styles }) => styles};
`;

const BulletDiv = styled.div`
  margin-right: 10px;
  width: 10%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
`;

const Bullets = ({ bullets, justifyContent, styles, bulletStyles, customTextSize }) => (
  <BulletsContainer justifyContent={justifyContent} styles={styles}>
    {bullets.map(bullet => (
      <Bullet key={bullet} styles={bulletStyles}>
        <BulletDiv>
          <Icon icon="checkmark3" color={palette.secondaryColor} size={20} style={{}} />
        </BulletDiv>
        <Text
          type="body1"
          styles={css`
            line-height: 1.5;
            width: 90%;
            ${customTextSize && `font-size: ${customTextSize}`}
          `}
        >
          {bullet}
        </Text>
      </Bullet>
    ))}
  </BulletsContainer>
);

Bullets.propTypes = {
  bullets: PropTypes.array,
};

Bullets.defaultProps = {
  bullets: [],
};

export default Bullets;
